import { ValidationSchema } from 'validation-schema-library';

const requisitesValidationSchema: ValidationSchema = {
  extendedInformation: {
    type: 'object',
    properties: {
      requisitesInformation: {
        type: 'object',
        required: {
          value: true,
          when: {
            $employeeType: {
              eq: 'CONTRACTOR',
            },
          },
        },
        _divisible: false,
        properties: {
          requisites: {
            type: 'string',
            maxSize: '60000',
            required: {
              value: true,
              when: [
                {
                  $_PERMISSIONS: {
                    ct: 'UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO',
                  },
                  $employeeType: {
                    eq: 'CONTRACTOR',
                  },
                },
              ],
            },
          },
          scansIds: {
            type: 'array',
            maxSize: '5',
          },
        },
      },
    },
  },
};

const getRequisitesValidationSchema = () => Promise.resolve(requisitesValidationSchema);

export default getRequisitesValidationSchema;
